@if (chatHistoryList && chatHistoryList.length > 0 && !isLoadingHistory) {
    <!-- Search Input -->
    <div class="search-container">
        <span class="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
        </span>
        <input
            class="search-input"
            type="text"
            [placeholder]="'AI_AGENT.SEARCH_CHAT' | translate"
            [attr.aria-label]="'AI_AGENT.SEARCH_CHAT' | translate"
            [(ngModel)]="searchQuery"
            (ngModelChange)="onSearchChange()" />
    </div>
    <div class="chat-history-container" (scroll)="onScroll($event)">
        @for (group of groupedDisplayedList; track group.displayDate) {
            <div class="history-group">
                <span class="history-group-date">{{group.displayDate}}</span>
                @for (historyItem of group.items; track trackByChatId($index, historyItem)) {
                    @if (historyItem.Title) {
                        <div class="chat-history-item" role="button" tabindex="0" (click)="loadChatHistory(historyItem)"
                            [class.chat-history-item--active]="selectedChatId === (historyItem.id || historyItem.chatId)">
                            <span class="history-title">{{historyItem.Title}}</span>
                        </div>
                    }
                }
            </div>
        }

        <!-- Loading Indicator -->
        @if (isLoading) {
            <div class="loading-indicator">
                <div class="default-chat-loader">
                    <nalco-refresh-loader [isLoading]="isLoading"></nalco-refresh-loader>
                </div>
            </div>
        }

        <!-- End of List Indicator -->
        @if (!hasMoreItems && displayedHistoryList && displayedHistoryList.length > initialHistoryCount) {
            <div class="end-of-list">
                <span>{{'AI_AGENT.NO_MORE_HISTORY' | translate}}</span>
            </div>
        }
    </div>

    <!-- No Search Results -->
    @if (hasNoSearchResults) {
        <div class="no-history-message">
            <img src="../../../../assets/Icon-Communication.svg" class="no-history-icon" />
            <p>{{'AI_AGENT.NO_HISTORY_FOUND' | translate}}</p>
        </div>
    }
}

@if (chatHistoryList && chatHistoryList.length === 0 && isLoadingHistory) {
    <div class="loading-chat-history-indicator">
        <div class="spinner">
            <nalco-refresh-loader [isLoading]="isLoadingHistory"></nalco-refresh-loader>
        </div>
    </div>
}

<!-- No History Message -->
@if (chatHistoryList && chatHistoryList.length === 0 && !isLoadingHistory) {
    <div class="no-history-message">
        <img src="../../../../assets/Icon-Communication.svg" class="no-history-icon" />
        <p>{{'AI_AGENT.NO_AVAILABLE_CHAT' | translate}}</p>
        <span>{{'AI_AGENT.START_NEW_CONVERSATION' | translate}}</span>
    </div>
}